export default {
  viewAll: 'View All',
  clearHistory: 'Clear History',
  noGamesAvailable: 'No games available',
  showMore: 'Show More',
  showLess: 'Show Less',
  loading: 'Loading...',
  error: 'Error',
  retry: 'Retry',
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  delete: 'Delete',
  edit: 'Edit',
  close: 'Close',
  submit: 'Submit',
  back: 'Back',
  next: 'Next',
  searchPlaceholder: 'Search games...',
  search: 'Search',
  noMoreGames: 'No more games',
  backToTop: 'Back to top'
}; 